"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbsoluteUrl = isAbsoluteUrl;
exports.getUrlParam = getUrlParam;
exports.setUrlParam = setUrlParam;
exports.setUrlParams = setUrlParams;
exports.combineUrls = combineUrls;
function isAbsoluteUrl(url) {
    return /\:/.test(url);
}
function getUrlParam(url, param) {
    var m = url.match(new RegExp(param + "=(.*?)(&|$|#)"));
    return m && decodeURIComponent(m[1]);
}
function setUrlParam(url, param, value) {
    var sep = url.indexOf("?") >= 0 ? "&" : "?";
    url = url.replace(new RegExp(param + "=.*?(&|$)", "g"), "");
    var encodedValue = value === null || value === undefined ? "" : encodeURIComponent(value);
    url = url + sep + param + "=" + encodedValue;
    url = url.replace("&&", "&");
    url = url.replace("?&", "?");
    return url;
}
function setUrlParams(url, keyValueCollection) {
    var baseUrl = url;
    for (var key in keyValueCollection) {
        if (keyValueCollection.hasOwnProperty(key))
            baseUrl = setUrlParam(baseUrl, key, keyValueCollection[key]);
    }
    return baseUrl;
}
function combineUrls(url, relativeUrl) {
    if (isAbsoluteUrl(relativeUrl))
        return relativeUrl;
    if (/^\//.test(relativeUrl)) {
        if (!isAbsoluteUrl(url))
            return relativeUrl;
        var protocol = url.split(":")[0];
        var domain = url.split(":")[1].replace(/^\/*/, "").replace(/\/.*/, "");
        return protocol + "://" + domain + relativeUrl;
    }
    return resolveRelativePath(url, relativeUrl);
}
function resolveRelativePath(url, relativePath) {
    url = url.replace(/\/*$/, "");
    var url1 = url.split("/");
    var url2 = relativePath.split("/");
    var url3 = [];
    for (var i = 0, l = url1.length; i < l; i++) {
        if (url1[i] == "..") {
            url3.pop();
        }
        else if (url1[i] == ".") {
            continue;
        }
        else {
            url3.push(url1[i]);
        }
    }
    for (var i = 0, l = url2.length; i < l; i++) {
        if (url2[i] == "..") {
            url3.pop();
        }
        else if (url2[i] == ".") {
            continue;
        }
        else {
            url3.push(url2[i]);
        }
    }
    return url3.join("/");
}
